<template>
  <div class="user-center">
    <div class="user-top">
      <div class="user-info" v-if="userInfor.user_id">
        <div
          class="user-img"
          :style="'background-image:url('+ (userInfor.avatar || getPhoto(userInfor.user)) +')'"
        ></div>
        <!-- <div v-if="isUser" class="user-edit" @click="alertUserEdit"></div> -->
        <div class="user-desc">
          <p>{{getName(userInfor.user)}}</p>
          <p>{{userInfor.title || '无'}}</p>
          <p>{{userInfor.dep}}</p>
        </div>
        <div class="line"></div>
      </div>
      <div class="user-context">
        <div class="user-edit"  v-if="isUser" @click="editMotto"></div>
        <pre>{{userInfor.motto}}</pre>
      </div>
      <div class="user-see">
        <p>{{userInfor.pv || 0}}</p>
        <p>收获目光</p>
      </div>
    </div>
    <div class="user-bottom">
      <div class="user-bottom-left">
        <div v-if="show[0]" class="post-card-box">
          <div class="post-cards">
            <PostCard v-for="item in categoryList[0].posts" :key="item._id" :post="item" />
          </div>
        </div>
        <div v-if="show[1]" class="course-card-box">
          <course-card
            v-for="item in categoryList[1].posts"
            :key="item._id"
            :course="item"
            class="course-cards"
          />
        </div>
        <div v-if="isUser && show[2]" class="post-card-box">
          <div class="post-cards">
            <PostCard v-for="item in categoryList[2].posts" :edit="true" :key="item._id" :post="item" :uid="$route.params.id"/>
          </div>
        </div>
        <div v-if="isUser && show[3]" class="course-card-box">
            <course-card
              v-for="item in categoryList[3].posts"
              :key="item._id"
              :course="item"
              :edit="true"
              :uid="$route.params.id"
              class="course-cards"
            />
        </div>
        <div v-if="isAuditUser && show[4]" class="post-card-box">
          <div class="post-cards">
            <PostCard v-for="item in auditList[0].posts" :edit="true" :key="item._id" :post="item" :audit="true" :uid="$route.params.id"/>
          </div>
        </div>
        <div v-if="isAuditUser && show[5]" class="course-card-box">
          <course-card
                  v-for="item in auditList[1].posts"
                  :key="item._id"
                  :course="item"
                  :edit="true"
                  :uid="$route.params.id"
                  class="course-cards"
                  :audit="true"
          />
        </div>
      </div>
      <div class="user-bottom-right">
        <ul class="no-auditState">
          <li
            @click="selectCategory(index)"
            v-for="(item, index) in (isUser ? categoryList : categoryList.slice(0, 2))"
            :key="index"
            :class="{active:show[index]}"
           >
          <p></p>
          <p>{{item.category}}（{{item.amount}}）</p>
          </li>
        </ul>
        <ul v-if="isAuditUser" class="auditState">
          <li
            @click="selectCategory(index+4)"
            v-for="(item, index) in auditList"
            :key="index"
            :class="{active:show[index+4]}"
           >
          <p></p>
          <p>{{item.category}}（{{item.amount}}）</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import PostCard from "@/components/post/PostCard";
import CourseCard from "@/components/course/CourseCard.vue";
import UnpublishCard from "@/components/post/UnpublishCard.vue";
import EditAvatar from "@/components/userInfor/editAvatar";
import EditMotto from "@/components/userInfor/editmotto";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "user-center",
  data () {
    return {
      categoryList:  [
        { category: "文章", posts: [], amount: 0},
        { category: "课程", posts: [], amount: 0},
        { category: "未发布文章", posts: [], amount: 0},
        { category: "未发布课程", posts: [], amount: 0}
      ],
      auditList: [
        {category: '待审核文章', posts: [], amount: 0},
        {category: '待审核课程', posts: [], amount: 0}
      ],
      show: [true, false, false, false,false,false]
    }
  },
  components: {
    PostCard,
    CourseCard,
    UnpublishCard
  },
  computed: {
    ...mapGetters('home', ['user']),
    ...mapGetters('userInfor', ['userInfor', 'userPosts', 'userAuditPosts']),
    isUser () {
      let isUser = this.user && (this.user.uid === this.$route.params.id) || false
      return isUser
    },
    isAuditUser () {
      let isAuditUser = this.isUser && (this.user.groupid === 2)
      return isAuditUser
    }
  },
  watch: {
    userPosts(newVal) {
      if (!newVal) return;
      let newCategoryList =  [
        { category: "文章", posts: [], amount: 0},
        { category: "课程", posts: [], amount: 0},
        { category: "未发布文章", posts: [], amount: 0},
        { category: "未发布课程", posts: [], amount: 0}
      ]
      newVal.forEach(element => {
        if (element.articleType === "0" && element.auditState === 4) {
          // 已发布文章
          newCategoryList[0].posts.push(element);
          newCategoryList[0].amount++;
        }
        if (element.articleType === "1" && element.auditState === 4) {
          // 已发布课程
          newCategoryList[1].posts.push(element);
          newCategoryList[1].amount++;
        }
        if (element.articleType === "0" && element.auditState !== 4) {
          // 未发布文章
          newCategoryList[2].posts.push(element);
          newCategoryList[2].amount++;
        }
        if (element.articleType === "1" && element.auditState !== 4) {
          // 未发布课程
          newCategoryList[3].posts.push(element);
          newCategoryList[3].amount++;
        }
      })
      this.categoryList = Object.assign([], newCategoryList)
      this.selectCategory(sessionStorage.getItem('currentIndex') || 0)

    },
    userAuditPosts(newVal) {
      if (!newVal) return;
      let newAuditCategoryList =  [
        {category: '待审核文章', posts: [], amount: 0},
        {category: '待审核课程', posts: [], amount: 0}
      ]
      newVal.forEach(element => {
        if (element.articleType === "0" && this.user.groupid === 2) {
          // 待审核文章
          newAuditCategoryList[0].posts.push(element);
          newAuditCategoryList[0].amount++;
        }
        if (element.articleType === "1" && this.user.groupid === 2) {
          // 待审核课程
          newAuditCategoryList[1].posts.push(element);
          newAuditCategoryList[1].amount++;
        }
      })
      this.auditList = Object.assign([], newAuditCategoryList)
      this.selectCategory(sessionStorage.getItem('currentIndex')  || 0)
    }
  },
  methods: {
    ...mapActions("userInfor", ["getUserInfor", "getUserPostList", "getUserAuditPosts"]),
    selectCategory(index) {
      this.$set(this.show, this.currentShow, false);
      this.$set(this.show, index, true);
      this.currentShow = index;
      sessionStorage.setItem('currentIndex', index)
    },
    editMotto() {
      EditMotto.open(this.userInfor.motto);
    },
    alertUserEdit () {
      EditAvatar.open(this.userInfor)
    }
  },
  created() {
    this.getUserInfor(this.$route.params.id);
    this.getUserPostList(this.$route.params.id);
    this.getUserAuditPosts()
    sessionStorage.setItem('currentIndex', 0)
  },
  beforeRouteUpdate (to, from, next) {
    this.getUserInfor(to.params.id);
    this.getUserPostList(to.params.id);
    this.getUserAuditPosts();
    this.selectCategory(sessionStorage.getItem('currentIndex'))
    next()
  },
};
</script>
<style  lang="scss">
.user-center {
  > .user-top {
    width: 100%;
    height: 191px;
    border-bottom: 1px solid rgba(234, 234, 234, 1);
    display: flex;
    flex-direction: row;
    > .user-info {
      position: relative;
      display: flex;
      flex-direction: row;
      width: 301px;
      > .user-edit {
        width: 20px;
        height: 20px;
        position: absolute;
        right: 10px;
        top: 45px;
        background-image: url("../assets/img/useredit.png");
        background-size: cover;
        &:hover {
          cursor: pointer;
        }
      }
      > .user-img {
        width: 100px;
        height: 100px;
        border: 1px solid rgba(234, 234, 234, 1);
        margin-top: 40px;
        border-radius: 50%;
        // background-image: url('http://api.kingdee.com/kdrive/user/file/thumbnail?file_id=46042344&client_id=200547&scode=bnMvd1JqdEZSNmlVdDFfcl9QOHl3&height=200&sign=3fb1e6d59626e0da8f4e7e5284b0e829ec57ccb9');
        background-size: cover;
      }
      > .user-desc {
        margin-top: 19px;
        margin-left: 30px;
        text-align: left;
        > p:nth-child(1) {
          font-size: 24px;
          font-family: MicrosoftYaHei-Bold;
          font-weight: bold;
          color: rgba(51, 51, 51, 1);
          line-height: 31px;
          margin-bottom: 20px;
        }
        > p:nth-child(2) {
          font-size: 14px;
          font-family: MicrosoftYaHei;
          color: rgba(51, 51, 51, 1);
          line-height: 19px;
          margin-bottom: 8px;
        }
        > p:nth-child(3) {
          font-size: 14px;
          font-family: MicrosoftYaHei;
          color: rgba(153, 153, 153, 1);
          line-height: 19px;
          margin-top: 8px;
        }
      }
      > .line {
        width: 1px;
        height: 95px;
        background-color: rgba(234, 234, 234, 1);
        margin-top: 44px;
        margin-left: 42px;
        position: absolute;
        right: 0;
      }
    }
    > .user-context {
      width: 594px;
      position: relative;
      padding-top: 42px;
      padding-left: 32px;
      text-align: left;
      > .user-edit {
        width: 20px;
        height: 20px;
        position: absolute;
        left: 618px;
        top: 45px;
        background-image: url("../assets/img/useredit.png");
        background-size: cover;
      }
      > p {
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: rgba(51, 51, 51, 1);
        line-height: 24px;
        margin: 0;
        text-align: left;
      }
    }
    > .user-see {
      padding-left: 88px;
      padding-top: 61px;
      > p:nth-child(1) {
        font-size: 40px;
        font-family: HYk1gj;
        color: rgba(254, 183, 5, 1);
        line-height: 40px;
        margin: 0;
      }
      > p:nth-child(2) {
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: rgba(51, 51, 51, 1);
        line-height: 24px;
        margin: 0;
      }
    }
  }
  > .user-bottom {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    > .user-bottom-left {
      width: 850px;
      height: 100%;
      margin-top: 26px;
      > .post-card-box {
        width: 850px;
        margin-top: -25px;
        > .post-cards {
          > :not(:first-child) {
            border-top: 1px solid rgba(234, 234, 234, 1);
          }
        }
      }
      > .course-card-box {
        width: 850px;
        margin-top: -51px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
        > .course-cards:nth-child(n) {
          margin-top: 50px;
        }
      }
    }
    > .user-bottom-right {
      width: 280px;
      height: 200px;
      padding-top: 14px;
      padding-left: 48px;
      ul {
        list-style: none;

        li {
          width: 280px;
          height: 52px;
          border-radius: 6px;
          font-size: 16px;
          font-family: MicrosoftYaHei;
          color: rgba(51, 51, 51, 1);
          line-height: 21px;
          text-align: left;
          display: flex;
          cursor: pointer;

          > p:nth-child(1) {
            width: 32px;
            height: 32px;
            border-radius: 4px;
            float: left;
            margin: 10px 21px 10px 12px;
          }
        }
        .active {
          background: rgba(248, 248, 248, 1);
        }
      }
      >ul:nth-child(1){
        > li:nth-child(1) {
          > p:nth-child(1) {
            background-image: url("../assets/img/article.png");
            background-size: cover;
          }
        }
        > li:nth-child(2) {
          > p:nth-child(1) {
            background-image: url("../assets/img/course.png");
            background-size: cover;
          }
        }
        > li:nth-child(3) {
          > p:nth-child(1) {
            background-image: url("../assets/img/unpost.png");
            background-size: cover;
          }
        }
        > li:nth-child(4) {
          > p:nth-child(1) {
            background-image: url("../assets/img/uncourse.png");
            background-size: cover;
          }
        }
      }
      >ul:nth-child(2){
        > li:nth-child(1) {
          > p:nth-child(1) {
            background-image: url("../assets/img/articlereview.png");
            background-size: cover;
          }
        }
        > li:nth-child(2) {
          > p:nth-child(1) {
            background-image: url("../assets/img/coursereview.png");
            background-size: cover;
          }
        }
      }

      }
    }

}
</style>

